{
  "LIB_ORDERS": {
    "COMMON": {
      "ACTION_LABELS": {
        "BACK": "Back",
        "PRINT": "Print",
        "ACTIONS": "Actions",
        "EDIT_CUSTOM_FIELDS": "Edit custom fields",
        "CLOSE": "Close",
        "CANCEL": "Cancel",
        "SCHEDULE_ACTIVATION": "Activate on contract start",
        "ACTIVATE_NOW": "Activate now",
        "PREVIEW": "Preview",
        "SEND": "Send"
      },
      "ORDERS": {
        "AGREE_TO_PURCHASE": "Agree to purchase",
        "PURCHASE": "Purchase",
        "PROCESS_ORDER": "Process order",
        "PAYMENT": "Payment",
        "DECLINE": "Decline",
        "DRAFT_ORDER": "Save as draft",
        "NO_LONGER_AVAILABLE": "This order can't be altered. For more info, please contact your sales representative.",
        "ORDER_FORM_LABEL": "Order form",
        "ORDER_FORMS_LABEL": "Order forms",
        "ORDER_FORMS_MISSING_INFORMATION": "<strong>Order forms</strong> &mdash; information is required before order can be submitted",
        "PRICING": "Pricing",
        "PRINT": "Print",
        "REVIEW": "Review order",
        "UPDATE_ORDER_FORM_ANSWERS": "Update order form answers",
        "LOGIN": "Log in",
        "ERROR": "Error",
        "ERROR_LOADING_MESSAGE": "We were unable to load this order",
        "ERROR_AT_LEAST_ONE_LINE_ITEM": "Order must have at least 1 line item. Please add an item.",
        "SUBMIT_ORDER": "Submit order",
        "CHARGE_AND_SUBMIT_ORDER": "Charge and submit order",
        "SUBMIT_FOR_CUSTOMER_APPROVAL": "Submit for customer approval",
        "RESUBMIT_FOR_CUSTOMER_APPROVAL": "Resubmit for customer approval",
        "CONVERT_TO_DRAFT": "Convert to draft",
        "CANCEL_ORDER": "Cancel order",
        "UNSUBSCRIBE_FROM_ORDER": "Unsubscribe from update notifications",
        "SUBSCRIBE_TO_ORDER": "Subscribe to update notifications",
        "TRY_AGAIN": "Try again",
        "TERMS_OF_SERVICE_ERROR": "You must agree to the Terms of Service to continue.",
        "ORDER_FORM_ERROR": "Some of the required fields aren't filled out. Update those and try again.",
        "PAYMENT_METHOD_ERROR": "A valid payment method is required.",
        "PAYMENT_METHOD_FAILURE": "Failed to save payment method.",
        "ERROR_CUSTOM_PRICE": "We could not update the amount. Please try again.",
        "SUCCESS_CUSTOM_PRICE": "Successfully updated the amount",
        "EDIT": "Edit",
        "ADD": "Add",
        "CANCEL": "Cancel",
        "UPLOAD": "Upload",
        "REQUIRED": "Required",
        "ERROR_LESS_THAN_ONE": "Must be 1 or greater",
        "ORDER_SUMMARY": "Order Summary",
        "INVALID_CARD_ERROR": "Invalid payment details.",
        "INVALID_USER_SIGNATURE_ERROR": "A signature is required.",
        "OVERVIEW_TAB_LABEL": "Overview",
        "FULFILLMENT_FORMS_LABEL": "Fulfillment forms",
        "REQUEST_TO_CANCEL_ORDER": "Cancel",
        "ARCHIVE_ORDER": "Archive order",
        "APPROVE_CANCELLATION_REQUEST": "Approve cancellation",
        "DECLINE_ORDER_CANCELLATION": "Decline cancellation",
        "APPROVE_SUBMITTED_ORDER": "Approve",
        "DECLINE_SUBMITTED_ORDER": "Decline",
        "ORDER_PREVIEW": "Order preview",
        "ALREADY_ACTIVE_POPOVER": "This order contains one or more items that are already active on this account. To avoid double-charging, remove the affected items before attempting to charge.",
        "DIALOGS": {
          "REQUEST_TO_CANCEL_ORDER": {
            "ADMIN": {
              "TITLE": "Cancel order?",
              "MESSAGE": "This action cannot be undone.",
              "LABEL": "Reasons for cancellation"
            },
            "SALESPERSON": {
              "TITLE": "Request to cancel order?",
              "MESSAGE": "Add any notes relevant to your request.",
              "LABEL": "Reasons for cancellation"
            },
            "REQUIRED": "Required",
            "SUBNOTES": "These notes will be appended to this order's existing Admin notes.",
            "CANCEL_ORDER": "Cancel order",
            "DONT_CANCEL": "Don't cancel",
            "SUCCESS_MESSAGE": "Order was successfully canceled",
            "ERROR_MESSAGE": "An error occurred. Please try again."
          },
          "APPROVE_CANCELLATION_REQUEST": {
            "TITLE": "Cancel order?",
            "MESSAGE": "Cancellation of this order will not affect any wholesale or retail subscriptions. Subscriptions can be managed via the account details page.",
            "CONFIRM": "Cancel order",
            "CANCEL": "Close",
            "SUCCESS_MESSAGE": "Order cancellation request was successfully approved",
            "ERROR_MESSAGE": "An error occurred. Please try again."
          },
          "ARCHIVE_ORDER": {
            "TITLE": "Archive order?",
            "MESSAGE": "This action cannot be undone. Archived orders are hidden from your list of orders unless viewed using the \"Archived\" filter.",
            "ARCHIVE": "Archive",
            "SUCCESS_MESSAGE": "Order was successfully archived",
            "ERROR_MESSAGE": "An error occurred. Please try again."
          },
          "DECLINE_ORDER_CANCELLATION": {
            "TITLE": "Decline request to cancel order?",
            "MESSAGE": "Add any notes relevant to declining this request.",
            "REQUIRED": "Required",
            "SUBNOTES": "These notes will be appended to this order's existing Admin notes.",
            "LABEL": "Reasons for declining",
            "DECLINE_REQUEST": "Decline request",
            "SUCCESS_MESSAGE": "Order cancellation was successfully declined",
            "ERROR_MESSAGE": "An error occurred. Please try again."
          },
          "APPROVE_SUBMITTED_ORDER": {
            "TITLE": "Approve order for {{businessName}}",
            "MESSAGE": "Once you've approved this order, the salesperson will be notified about its approval. To activate the products included within the order, continue to the next step.",
            "CONFIRM": "Approve & Continue",
            "CANCEL": "Cancel",
            "SUCCESS_MESSAGE": "Order was successfully approved",
            "ERROR_MESSAGE": "An error occurred. Please try again."
          },
          "DECLINE_SUBMITTED_ORDER": {
            "TITLE": "Decline order for {{businessName}}",
            "MESSAGE": "This will send an email to the salesperson to alert them the order has been declined",
            "CONFIRM": "Decline order",
            "CANCEL": "Cancel",
            "SUCCESS_MESSAGE": "Order was successfully declined",
            "ERROR_MESSAGE": "An error occurred. Please try again.",
            "DECLINE_REASON_VALIDATION": "Select a decline reason",
            "DECLINE_MESSAGE_VALIDATION": "Enter a decline message",
            "DECLINE_REASON": {
              "TRY_AGAIN": "Try again",
              "DECLINE_MESSAGE_TITLE": "Decline message",
              "DECLINE_MESSAGE_INFO": "Enter more information for the salesperson",
              "REASONS_TITLE": "Why are you declining this order?",
              "REQUIRED": "Required",
              "MANAGE_REASONS": "Manage reasons"
            }
          },
          "INVALID_BILLING_TERMS": {
            "TITLE": "Reschedule order items to continue",
            "MESSAGE": "One or more items on this order are scheduled to start before the contract start date of <b>{{date}}</b>. Reschedule affected items to continue."
          },
          "ORDERS_SELECT_PAYMENT_METHOD": {
            "BILLING_RECIPIENT": "Billing recipient",
            "BILLING_RECIPIENT_HINT": "All billing communications will be sent to this contact",
            "CHARGE_PAYMENT_METHOD": "Charge payment method",
            "BILLING_RECIPIENT_REQUIRED": "A billing recipient is required",
            "NO_CREDIT_CARD_PAYMENT_METHODS": "No credit card payment methods on file"
          },
          "COLLECT_PAYMENT": {
            "TITLE": "Collect payment",
            "SUBTITLE": "How will you collect payment from your customer?",
            "CHARGE_SAVED": "Charge saved payment method",
            "AFTER_SUCCESS": "Order will be processed after successful payment",
            "ADD_METHOD": "Add and charge a payment method",
            "SEND_TO_CUSTOMER": "Send to customer for approval and payment",
            "PROCESS_AFTER_APPROVAL": "Order will be processed after your customer approves it",
            "SKIP_PAYMENT": "Skip collecting payment for now",
            "PROCESS_IMMEDIATELY": "Order will be processed immediately",
            "PROCESS_ORDER": "Process order?",
            "ON_CONTRACT_START": "Order items will activate on the contract start date.",
            "CONFIRM_BILLED": "I understand that I will be billed for activated products. Once activated, these products will be available in Business App for this account.",
            "CONFIRM": "Confirm"
          }
        }
      },
      "EDIT_ORDERS": {
        "FULFILLMENT_TITLE": "Fulfillment orders",
        "VIEW_LINK": "View",
        "DETAILS_NEEDED_BANNER": "Details Needed",
        "DETAILS_NEEDED_BANNER_DESCRIPTION": "Fulfillment form information is required for an item",
        "VIEW_FORMS": "View forms",
        "RETAIL_SUMMARY": {
          "TITLE": "Retail Summary",
          "SUBTOTAL": "Subtotal",
          "TAXES": "Taxes",
          "DUE_NOW": "Due now",
          "RECURRING_CHARGES": "Recurring charges",
          "EDIT": "Edit",
          "ADD_CARD": "+ Add card",
          "ADD_CUSTOMER_PAYMENT_METHOD": "+ Add customer payment method",
          "SUBMIT_TEXT": "Save",
          "EMPTY_TEXT": "No payment card selected",
          "ERROR": "An error occurred. Please try again",
          "APPROVED_MESSAGE": "Order has been approved",
          "FUTURE_PAYMENTS": {
            "FUTURE_PAYMENTS": "Future payments",
            "ON_DATE": "on {{date}}",
            "STARTING_IMMEDIATELY": "starting immediately",
            "STARTING": "starting {{date}}",
            "FOR_DURATION_FREQUENCY": "for {{duration}}",
            "MONTHS": "months",
            "YEARS": "years"
          }
        },
        "WHOLESALE_SUMMARY": {
          "TITLE": "Wholesale Summary"
        },
        "SUBMIT_FOR_CHARGE_DIALOG": {
          "TITLE": "Charge payment method and activate order?",
          "MESSAGE": "<p>After successful payment, this order will activate on its contract start date.</p> <p>If payment fails, the order will be marked as Declined.</p>",
          "CONFIRM_CHECKBOX": "I understand that this customer will be charged when this order is submitted",
          "CONFIRM_PARTNER_BILLED_CHECKBOX": "I understand that I will be billed for activated products. Once activated, these products will be available in Business App for this account.",
          "CHARGE_AND_ACTIVATE": "Charge and activate",
          "CANCEL": "Cancel"
        },
        "FULFILLMENT": {
          "PROJECTS": "Projects"
        }
      },
      "ORDER_DETAILS": {
        "TITLE": "Order details",
        "COMPANY": "Company",
        "ADDRESS": "Address",
        "COMPANY_AND_ADDRESS": "Company & Address",
        "COMPANY_NAME_AND_ADDRESS": "Company name and address",
        "CONTRACT_START": "Contract Start",
        "CONTRACT_DURATION": "Contract Duration",
        "CONTRACT_START_UPDATE_ERROR": "Failed to update contract start date.",
        "CONTRACT_DURATION_UPDATE_ERROR": "Failed to update contract duration.",
        "ENFORCE_CONTRACT_TERM_UPDATE_ERROR": "Failed to update enforce contract term.",
        "NO_CONTRACT_DURATION": "No contract length",
        "CUSTOMER_AGREEMENTS": "Customer agreements",
        "LENGTH": "Length",
        "FREQUENCY": "Frequency",
        "VARIABLE_PRICES_TITLE": "Variable prices",
        "CUSTOMER_NOTES_TITLE": "Customer notes",
        "CUSTOMER_NOTES_INFO": "Customers can see these notes.",
        "ADMINISTRATIVE_NOTES_TITLE": "Admin notes",
        "ADMINISTRATIVE_NOTES_INFO": "Only salespeople and administrators can see these notes.",
        "EMPTY_NOTES": "No notes added",
        "NOTES_UPDATE_ERROR": "Failed to update notes.",
        "ADMINISTRATOR_ATTACHMENTS": "Admin attachments",
        "CUSTOMER_ATTACHMENTS": "Customer attachments",
        "ADMIN_ATTACHMENTS_SUBTITLE": "Only salespeople and administrators can see these attachments",
        "CUSTOMER_ATTACHMENTS_SUBTITLE": "Customers can see these attachments",
        "UPLOAD_ATTACHMENTS": "Upload attachments",
        "EMPTY_ATTACHMENTS": "No files added",
        "SUCCESSFUL_UPLOAD": "Successfully uploaded {{numberFilesUploaded}} file(s)",
        "SUBMITTED_BY": "Submitted by:",
        "CREATED_BY": "Created by",
        "ACCEPTED_ON": "Accepted on {{date}} by {{name}}",
        "TAGS": "Tags",
        "EMPTY_TAGS": "No tags added",
        "NEW_TAG": "Add {{newTag}} as a new tag",
        "TAGS_UPDATE_ERROR": "Your tags couldn't be updated. Please try again.",
        "ENFORCE_CONTRACT_TERM_TAG": "enforce contract term",
        "CONTRACT_DURATIONS": {
          "DAY": "day(s)",
          "WEEK": "week(s)",
          "MONTH": "month(s)",
          "YEAR": "year(s)"
        },
        "ENFORCE_CONTRACT_TERMS": "End subscriptions and deactivate items when contract ends",
        "SALESPERSON": "Salesperson",
        "SYSTEM": "System",
        "SYSTEM_ADMIN": "System admin"
      },
      "ORDER_CURRENCY": {
        "TITLE": "Order Currency",
        "DESCRIPTION": "Optionally override the currency on the order. You must manually update the prices on the order items to reflect the chosen currency.",
        "VMF_ONLY_BADGE": "VMF ONLY",
        "DEFAULT_OPTION": "Default"
      },
      "LINE_ITEMS": {
        "TITLE": "Order contents",
        "ITEM": "Item",
        "QUANTITY": "Quantity",
        "UNIT_PRICE": "Unit Price",
        "DISCOUNT": "Discount",
        "FREQUENCY": "Frequency",
        "REMOVE": "Remove item",
        "ADD": "Add items",
        "ADD_ROW": "Add row",
        "REMOVE_ROW": "Remove row",
        "GREATER_THAN_ZERO": "Must be greater than 0",
        "EDITION": "Edition",
        "EDITION_REQUIRED_FOR_PRICE": "Edition required to set price",
        "QUANTITY_DISABLED": "You can only activate one of these at a time",
        "REVENUE_REQUIRED": "Price is required",
        "GREATER_THAN_OR_EQUAL_TO_ZERO": "Must be greater than or equal to zero",
        "MUST_BE_NUM": "Must be a number",
        "FREQUENCY_REQUIRED": "Frequency is required"
      },
      "ACTIVITY": {
        "TITLE": "Activity",
        "CREATED_BY": "Created by {{name}}"
      },
      "SUMMARY": {
        "TITLE": "Retail Summary"
      },
      "ORDER_SUBMITTED": {
        "ORDER_SUBMITTED": "Order submitted",
        "RECEIVE_CONFIRMATION_SHORTLY": "Thank you for your order, it will be processed shortly.",
        "ITEM_HAS_FULFILLMENT_FORM": "Some items may require additional information from you or your client before they can be fulfilled.",
        "VIEW_ACCOUNT_DETAILS": "View account details",
        "SUCCESS": "Success!",
        "ORDER_HAS_BEEN_RECEIVED": "Your order has been received.",
        "FULFILLMENT_FORMS": "Fulfillment forms",
        "FULFILLMENT_FORMS_SUBTITLE": "The forms below will need to get completed before fulfillment can begin",
        "BACK_TO_ACCOUNT": "Back to account",
        "VIEW_ORDER": "View order"
      },
      "ERRORS": {
        "GENERIC_ERROR": "An error occurred"
      }
    },
    "FULFILLMENT": {
      "TITLE": "Fulfillment",
      "SUBTITLE": "Some products have Task Manager projects tied to them. These are available at no extra cost.",
      "SERVICE_PROVIDER": "Service Provider",
      "PRODUCTS": "Products",
      "PROJECT_NAME": "Project Name",
      "YOU": "You",
      "LEARN_MORE": "Learn more",
      "LEARN_MORE_DIALOG": {
        "TITLE": "Fulfillment projects",
        "DESCRIPTION_LINE_1": "Your Vendasta subscription includes access to Task Manager. This tool allows you to track and fulfill services on behalf of your clients all in one place.",
        "DESCRIPTION_LINE_2": "Some of the products in this order have a corresponding Task Manager project available. These projects come in two flavors, depending on who is set to fulfill them",
        "SERVICE_PROVIDER_TITLE": "You're the service provider",
        "SERVICE_PROVIDER_DESCRIPTION": "Projects give you guidance on how to fulfill on those services, so even if you aren't familiar with the product, you can assist your customer.",
        "NOT_SERVICE_PROVIDER_TITLE": "You're not the service provider",
        "NOT_SERVICE_PROVIDER_DESCRIPTION": "You can track the progress of these projects in Task Manager, allowing you to provide meaningful status updates to your clients."
      },
      "PROJECTS": "Projects",
      "FULFILLMENT_FORMS": "Fulfillment forms",
      "SHARE": "Share"
    },
    "FULFILLMENT_STATUS": {
      "TITLE": "Fulfillment status",
      "ACTIVATED": "Activated",
      "ERRORED": "Activation error",
      "ALREADY_ACTIVATED": "Already activated",
      "IGNORED_ERRORS": "Errors ignored",
      "PENDING": "Pending activation",
      "IGNORE_ERRORS_OPTION_LABEL": "Ignore errors",
      "SCHEDULED": "Scheduled",
      "UNSCHEDULED": "Unscheduled"
    },
    "SALES_ORDERS": {
      "ORDERS": "Orders",
      "ORDER_SUBMITTED": "Order submitted",
      "ADDITIONAL_INFORMATION": "Enter additional information",
      "BUSINESS": "Business",
      "CANNOT_PROCESS_ORDER": "We cannot process your order at this time. Please contact your administrator.",
      "CONFIRM_ACCOUNT_INFO": "Confirm account information",
      "CONTRACT_START_DATE": "Contract start date",
      "CONTRACT_START_HINT": "Orders will be automatically activated on the contract start date",
      "CREATE_ORDER_CALL_TO_ACTION": "Create an order for this account by selecting packages, choosing an activation date, and adding any relevant notes.",
      "CREATE_ORDER_SHORT": "Create order",
      "INFORMATION_FOR_PRODUCTS": "The following information will be provided to the products that require it.",
      "WILL_NOT_UPDATE": "Editing this will not update the account",
      "MAX_NUMBER_OF_FILES": "Max {{numberOfFiles}} files. Zip common files together if more are needed.",
      "ACTIVATED_UPON_APPROVAL": "The products within each package will be activated upon approval.",
      "USES_COMMON_FIELDS_FROM": "Uses common fields from ",
      "ORDER_DETAILS": "Order details",
      "NO_PACKAGES": "This is where you order packages of products and services for your clients. Come back to begin ordering packages as they become available.",
      "NOTES_FOR_ADMINISTRATOR": "Notes for administrator",
      "NOTES_HINT": "These notes will be hidden from the customer, and only visible to admins and salespeople.",
      "NOTES_FOR_CUSTOMER": "Notes for customer",
      "CUSTOMER_NOTES_HINT": "These notes will be visible to the customer.",
      "SUBMIT_ORDER": "Submit order",
      "SUBMIT_FOR_ADMIN_APPROVAL": "Submit for admin approval",
      "SUBMIT_FOR_CUSTOMER_APPROVAL": "Submit for customer approval",
      "CANNOT_SUBMIT_NO_USERS": "No users on account",
      "ADD_USER_AND_SUBMIT_FOR_CUSTOMER_APPROVAL": "Add user and send",
      "ADD_USER": "Add user",
      "ADD_EXPIRY": "Offer expiry date",
      "ADD_EXPIRY_ERROR": "Offer expiry must be future date and time",
      "ADD_EXPIRY_HINT": "Note that the customer will not be able to approve this order after the expiry date. The order will automatically become archived.",
      "REQUIRE_CUSTOMER_PAYMENT": "Require payment",
      "REQUIRE_CUSTOMER_PAYMENT_HINT": "Recipient must enter payment information before approving order",
      "SELECT_PACKAGES": "Select packages *",
      "SELECT_OPPORTUNITY": "Select opportunity",
      "DRAFT_ORDER": "Save as draft",
      "SAVE_AND_CONTINUE": "Save and continue",
      "ADD_ITEM": "Add Item",
      "UPDATE_SALESPERSON": "Update salesperson",
      "COMMON_FIELDS": {
        "BUSINESS_ACCOUNT_GROUP_ID": "Business account group ID",
        "BUSINESS_NAME": "Business name",
        "BUSINESS_ADDRESS": "Business address",
        "BUSINESS_PHONE_NUMBER": "Business phone number",
        "BUSINESS_WEBSITE": "Business website",
        "CONTACT_EMAIL": "Contact email",
        "CONTACT_NAME": "Contact name",
        "CONTACT_PHONE_NUMBER": "Contact phone number",
        "SALESPERSON_NAME": "Salesperson name",
        "SALESPERSON_EMAIL": "Salesperson email",
        "SALESPERSON_PHONE_NUMBER": "Salesperson phone number"
      },
      "SELECT_SALESPERSON": "Select salesperson",
      "ERROR_UPDATING_SALESPERSON": "There was an error updating the salesperson associated with this order",
      "SUCCESS_UPDATING_SALESPERSON": "The salesperson associated with this order has been successfully updated",
      "SALESPERSON": "Salesperson",
      "ACTIVATION_WARNING": {
        "WARNING_AFTER_LISTING_PACKAGES": " for this account.",
        "WARNING_BEFORE_LISTING_PACKAGES": "We noticed that you have already activated "
      },
      "BREADCRUMBS": {
        "BUSINESS": "Business",
        "CREATE_ORDER": "Create order",
        "MANAGE_ACCOUNTS": "Manage accounts"
      },
      "ERRORS": {
        "BAD_DATE_FORMAT": "Invalid date format",
        "DATE_BEFORE_TODAY": "Date cannot be before today",
        "FORM_IS_NOT_VALID": "Form is not valid.",
        "PREREQ_FORM_IS_NOT_VALID": "Required fields in the Account Information section haven’t been filled out or are incorrect.",
        "ATTACHMENT_ERROR": "Something went wrong uploading the attachment",
        "CANNOT_GET_BUSINESS": "Failed to get the business. Please try again later!",
        "ORDER_NOT_CREATED": "Creating Sales Order Failed! Try again.",
        "ORDER_NOT_SENT": "Failed sending sales order, please try again",
        "ORDER_NOT_SUBMITTED": "There was an error submitting the sales order, please try again",
        "FAILED_TO_IGNORE_ALL_PRODUCT_ACTIVATION_ERRORS": "Failed to ignore all product activation errors",
        "FAILED_TO_CREATE_INVOICE": "There was an error creating invoice, please try again",
        "FILL_OUT_REQUIRED_FORMS": "Please fill out all required forms",
        "INVALID_PRODUCTS_ERROR": "There are products included in this order that are not able to be activated. Please check your package contents.",
        "GENERIC_ERROR_TRY_AGAIN": "An error occurred. Please try again.",
        "ACTIVATED_WITH_ERRORS": "Order activated with errors"
      },
      "SUCCESS": {
        "ORDER_SUBMITTED": "Order was successfully submitted",
        "ORDER_DRAFTED": "Draft of order was successfully saved",
        "ORDER_UPDATED": "Order was successfully updated.",
        "ORDER_SENT": "Order was successfully sent",
        "ACTIVATION_IN_PROCESS": "The order activation is in progress",
        "ORDER_ACTIVATED": "Order successfully activated",
        "ORDER_SCHEDULED": "The order is scheduled for activation"
      },
      "RESPONSES": {
        "NO_DONT_SEND": "Don't send",
        "YES_SEND_FOR_APPROVAL": "Send for approval"
      },
      "ORDER_SUMMARY": "Order Summary",
      "ORDER_CONTENTS": "Order Contents",
      "CANT_EDIT": "You can only edit draft sales orders",
      "QUANTITY_DISABLED": "You can only activate one of these at a time.",
      "CANCEL_ORDER": "Cancel order",
      "CANCEL_ORDER_DIALOG": {
        "DESCRIPTION": "This will submit a cancellation request to your admin. Add any notes that might be relevant for this cancellation. These notes will be appended to the end of this Order's notes.",
        "DONT_CANCEL": "Don't cancel",
        "REQUEST_CANCELLATION": "Request cancellation",
        "CANCELLATION_REQUESTED": "The cancellation has been requested",
        "ERROR_REQUESTING": "There was an error requesting the cancellation, please try again."
      },
      "DUPLICATE_ORDER": "Duplicate order",
      "CONVERT_TO_DRAFT": "Convert to draft",
      "CONVERTED_TO_DRAFT": "Converted to draft",
      "ERROR_CONVERTING_TO_DRAFT": "There was an error converting this order to draft",
      "ERROR_CHANGING_SUBSCRIPTION": "There was an error changing your subscription to this order",
      "SUBSCRIBED": "Subscribed",
      "UNSUBSCRIBED": "Unsubscribed",
      "RESEND_TO_CUSTOMER": "Resend to a customer",
      "RESEND_WARNING": "This order was sent to a customer before. Resending the order to a customer will reset the order back to <b>Awaiting customer approval</b> status.",
      "ERROR_AT_LEAST_ONE_LINE_ITEM": "You must add at least one item to the order contents",
      "UNSAVED_CHANGES_TITLE": "Proceed without changes?",
      "UNSAVED_CHANGES_PROMPT": "There are unsaved changes to the business profile. Do you want to proceed?",
      "PROCEED_WITHOUT_CHANGES": "Discard changes and proceed",
      "REVIEW_CHANGES": "Review changes",
      "SUBSCRIBE": "Subscribe to updates",
      "UNSUBSCRIBE": "Unsubscribe from updates",
      "LEASED_TO_AUTOMATIONS": "Sent to automations",
      "WARNINGS": {
        "MISSING_PRODUCT_REQUIREMENTS": "{{productName}} requires products that aren't yet active on this account. Add the required products to your order or contact your administrator to order {{productName}}.",
        "MISSING_PRODUCT_PARENT": "{{parentProductName}} is required to activate {{productName}}. Add {{parentProductName}} to your order or contact your administrator to order {{productName}}.",
        "INVALID_LINE_ITEMS_BANNER_WARNING": "This order contains one or more items that are ",
        "INVALID_LINE_ITEMS_BANNER_ALREADY_ACTIVE": "already active for this account{{invalidLineItems}}",
        "INVALID_LINE_ITEMS_BANNER_INVALID_BILLING_TERMS": "scheduled to start before the contract start date of <b>{{date}}</b>{{invalidLineItems}}"
      },
      "CREATE_ORDER_DIALOG": {
        "CREATE_NEW_ORDER": "Create new order",
        "OPEN_LAST_DRAFT": "Open last draft",
        "CONTRACT_START_DATE": "Contract start: {{date}}"
      },
      "INVALID_ORDER_FORMS_DIALOG": {
        "TITLE": "Complete order forms",
        "MESSAGE": "This order can't be submitted until all required information has been filled out in the Order forms tab.",
        "GO_TO_FORMS": "Go to Order Forms"
      },
      "ACTIVE_ITEMS": "Active items",
      "IGNORE_ALL_ERRORS": "Ignore all errors",
      "IGNORE_ALL_ERRORS_TOOLTIP": "You can only ignore errors when the order has the 'Activation Errors' status",
      "ACTIVATION_DATE_CONFIRMATION_DIALOG": {
        "TITLE": "Review contract start date",
        "MESSAGE": "This order's contract start date is scheduled for <b>{{date}}</b>. We recommend setting the contract start date as  <b>{{today}}</b>, as your customer's products will be delivered today.",
        "MESSAGE_2": "Choose your preferred date to confirm this order and activate the products.",
        "KEEP_ORIGINAL_DATE": "Keep original date",
        "USE_TODAY": "Use today's date",
        "ERROR_REQUESTED_ACTIVATION_UPDATE": "Failed to update contract start date, please try again."
      },
      "I_UNDERSTAND_I_WILL_BE_BILLED": "I understand that I will be billed for activated products. Once activated, these products will be available in {{businessAppName}} for this account.",
      "DISCARD_UNSAVED_CHANGES_DIALOG": {
        "TITLE": "Proceed without changes?",
        "MESSAGE": "There are unsaved changes to the business profile. Do you want to proceed?",
        "PROCEED_WITHOUT_CHANGES": "Discard changes and proceed",
        "REVIEW_CHANGES": "Review changes"
      },
      "SUBMIT_ORDER_FOR_APPROVAL": {
        "SELECT": "Select contact",
        "ASSOCIATE": "Associate contact",
        "SELECT_FOR_ASSOCIATION": "Select contact to associate",
        "ASSOCIATE_RECIPIENT_WITH_OWNERSHIP_ENTITY": "Associate contact with company",
        "ORDER_SUBMISSION_FAILED": "Order submission failed. Please try again.",
        "ASSOCIATION_FAILED": "Contact association failed. Please try again.",
        "NO_ASSOCIATIONS": "No associated contacts on company",
        "CONTACT_REQUIRES_EMAIL": "Contact with email is required"
      }
    },
    "MANUAL_AUTOMATIONS": {
      "START_AUTOMATION_TITLE": "Start manual automation"
    },
    "ORDER_CONFIRMATION": {
      "TITLE": "Order confirmation",
      "TOTAL": "Total",
      "CONFIRMATION": "I agree to being billed the above amount by {{ partner_name }}. I understand that this order must be processed before I am able to access requested features.",
      "TERMS_OF_SERVICE_CONFIRMATION": "I agree to the <a target=\"_blank\" href=\"{{terms_of_service_url}}\">Terms of Service</a> and I have authority to make financial decisions on behalf of the business",
      "CANT_PURCHASE_IMPERSONATING": "An impersonated user cannot purchase a product. Please login directly to complete the purchase.",
      "SUBMITTED": "Your order was sent successfully.",
      "ERROR_MISSING_FORM": "Missing order form, please retry.",
      "CANNOT_BIY_PACKAGE_WARNING": "Your cart contains one or more items that require additional processing time. Our team will work to get it approved as soon as possible:\n    \u2022 {{package_names}}",
      "TERMS_OF_SERVICE_ERROR": "You must check the confirmation checkboxes."
    }
  }
}
